import './App.css';

function App() {
  return (
    
    <div className="App">
      <div className='video-background'>
        <div className='content'>
          <header className="App-header">
            <img src="https://random.imagecdn.app/400/400" className="App-logo" alt="logo" />
            <h1>Welcome to thedream.dev!</h1>
            <audio id="myAudio" controls autoplay loop>
              <source src="./pedro.mp3" type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          </header>
        <img src="https://media1.tenor.com/m/ZAMoMuQgf9UAAAAd/mapache-pedro.gif" alt="pedro" />
        </div>
      </div>
    </div>
  );
}


export default App;
